export default function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <div className="spinner-wrapper">
        <div className="spinner"></div>
        <p className="loading-text">
          Loading
          <span className="dot dot1">.</span>
          <span className="dot dot2">.</span>
          <span className="dot dot3">.</span>
        </p>
      </div>
    </div>
  )
}
